import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  FaCog,
  FaUserCircle,
  FaShoppingCart,
  FaSignOutAlt,
  FaTrash,
  FaHome,
  FaBoxOpen,
  FaUnlockAlt,
  FaSchool,
} from "react-icons/fa";
import axios from "axios";
import Swal from "sweetalert2"; // SwatAlert use karein alert ki jagah
import { API_BASE_URL } from "../config/api";


function Header() {
  const [open, setOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [parentId, setParentId] = useState(localStorage.getItem("parentId"));
  const [parentName, setParentName] = useState(localStorage.getItem("parentName"));
  const navigate = useNavigate();

  // ⭐ Function jo state update karega
  const updateUserData = () => {
    setParentId(localStorage.getItem("parentId"));
    setParentName(localStorage.getItem("parentName"));
    fetchCartCount();
  };

  // Fetch cart count
  const fetchCartCount = async () => {

  const currentId = localStorage.getItem("parentId");

  if (!currentId) return;

  try {

    const res = await axios.get(
      `${API_BASE_URL}/cart/${currentId}`
    );

    let total = 0;

    res.data.forEach(item => {
      total += item.quantity;
    });

    setCartCount(total);

  } catch (err) {

    console.log("Cart fetch error:", err);

  }

};

  useEffect(() => {
    updateUserData();

    // ⭐ 1. Storage change listener (dusre tabs ke liye)
    window.addEventListener("storage", updateUserData);

    // ⭐ 2. Custom event listener (jab login ya school change ho)
    window.addEventListener("userDataUpdate", updateUserData);
    window.addEventListener("schoolChange", updateUserData);

    // ⭐ 3. Cart update listener (jab add to cart ho ya cart modify ho)
    window.addEventListener("cartUpdate", fetchCartCount);

    return () => {
      window.removeEventListener("storage", updateUserData);
      window.removeEventListener("userDataUpdate", updateUserData);
      window.removeEventListener("schoolChange", updateUserData);
      window.removeEventListener("cartUpdate", fetchCartCount);
    };
  }, []);

  // Logout function
  const logout = () => {
    setOpen(false);
    localStorage.clear();
    setParentId(null);
    setParentName(null);
    navigate("/");
    window.location.reload(); // State puri tarah clear karne ke liye
  };

  // Delete account
  const deleteAccount = async () => {
    const result = await Swal.fire({
        title: 'Are you sure?',
        text: "This will permanently delete your account and orders!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Yes, delete it!'
    });

    if (result.isConfirmed) {
      try {
        await axios.delete(`${API_BASE_URL}/parent/delete-account/${parentId}`);
        localStorage.clear();
        setParentId(null);
        setParentName(null);
        setCartCount(0);
        Swal.fire('Deleted!', 'Your account has been deleted.', 'success');
        navigate("/");
      } catch (err) {
        Swal.fire(
          'Error',
          err.response?.data?.message || 'Error deleting account.',
          'error'
        );
      }
    }
  };

  return (
    <>
      <nav
        className="navbar navbar-expand-lg py-2 sticky-top shadow-sm"
        style={{ backgroundColor: "#097969", zIndex: 1050 }}
      >
        <div className="container">
          {/* Logo */}
         {/* Logo */}
{/* Logo */}
<Link
  className="navbar-brand d-flex align-items-center"
  to="/"
  onClick={() => setOpen(false)}
  style={{ padding: "0" }} // Extra padding hatane ke liye
>
 <img 
  src="/logo.png"  /* Agar aapne rename karke logo.png kiya hai */
  alt="Uniform NX Logo" 
  style={{ 
    height: "65px", 
    width: "auto", 
    objectFit: "contain",
    display: "block",
    transition: "transform 0.3s ease" 
  }} 
  className="logo-img"
/>
</Link>
          {/* Desktop Menu */}
          <div className="d-none d-lg-flex gap-4 align-items-center">
            {!parentId ? (
              <>
                <Link to="/" className="nav-link text-white">Home</Link>
                <Link to="/login" className="nav-link text-white">Admin</Link>
                <Link to="/parent/login" className="nav-link text-white">School Uniform</Link>
              </>
            ) : (
              <>
                <Link to="/parent/uniform" className="nav-link text-light nav-link-custom">Uniform</Link>
                <Link
                  to="/parent/cart"
                  className="nav-link text-white d-flex align-items-center gap-2 nav-link-custom position-relative"
                >
                  <FaShoppingCart /> Cart
                  {cartCount > 0 && (
  <span
    className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger"
    style={{ fontSize: "9px" }}
  >
    {cartCount}
  </span>
)}
                </Link>
                <Link to="/parent/orders" className="nav-link text-light nav-link-custom">My Orders</Link>

                {/* User Profile Info */}
                <div className="d-flex align-items-center gap-3 bg-white bg-opacity-10 px-3 py-1 rounded-pill border border-white border-opacity-25">
                  <div className="text-light d-flex align-items-center gap-2">
                    <FaUserCircle size={18} />
                    <span style={{ fontSize: "14px", fontWeight: "500" }}>
                      {parentName || "Parent"} {/* Undefined handle kiya */}
                    </span>
                  </div>
                  <div className="vr text-white opacity-50" style={{ height: "15px" }}></div>
                  <button className="btn btn-link text-white p-0 text-decoration-none d-flex align-items-center gap-1" onClick={logout}>
                    <FaSignOutAlt size={16} /> <span style={{ fontSize: "13px" }}>Logout</span>
                  </button>
                </div>

                {/* Settings Cog */}
                <div className="settings-wrapper position-relative ms-2">
                  <button className="btn btn-outline-light rounded-circle p-1 d-flex align-items-center justify-content-center" style={{ width: "35px", height: "35px" }}>
                    <FaCog className="cog-icon" />
                  </button>
                  <div className="settings-dropdown shadow-lg">
                    <div className="p-2">
                      <small className="text-muted px-2 d-block mb-1" style={{ fontSize: "10px", fontWeight: "bold" }}>OPTIONS</small>
                      <Link to="/parent/forgot" className="dropdown-item py-2 rounded">Forgot Password</Link>
                      <Link to="/parent/change-school" className="dropdown-item py-2 rounded">Change School</Link>
                      <hr className="my-2" />
                      <button className="dropdown-item py-2 rounded text-danger d-flex align-items-center gap-2" onClick={deleteAccount}>
                        <FaTrash size={12} /> Permanent Delete
                      </button>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>

          {/* Mobile Toggle */}
          <button className="btn text-white d-lg-none border-0" onClick={() => setOpen(!open)} style={{ zIndex: 1100 }}>
            <span className="fs-3">{open ? "✕" : "☰"}</span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${open ? "active" : ""}`}>
        <div className="mobile-menu-content p-4">
          <div className="text-center mb-4">
            <FaUserCircle size={50} className="text-light opacity-50 mb-2" />
            <h5 className="text-white mb-0">{parentId ? (parentName || "Parent") : "Welcome Guest"}</h5>
          </div>
          <div className="d-flex flex-column gap-2">
            {!parentId ? (
              <>
                <Link to="/" className="mobile-link" onClick={() => setOpen(false)}>Home</Link>
                <Link to="/parent/login" className="mobile-link" onClick={() => setOpen(false)}>Parent Login</Link>
              </>
            ) : (
              <>
                <Link to="/parent/uniform" className="mobile-link" onClick={() => setOpen(false)}><FaHome /> Uniform Shop</Link>
                <Link to="/parent/cart" className="mobile-link" onClick={() => setOpen(false)}><FaShoppingCart /> My Cart</Link>
                <Link to="/parent/orders" className="mobile-link" onClick={() => setOpen(false)}><FaBoxOpen /> My Orders</Link>
                <div className="mt-3 pt-3 border-top border-white border-opacity-10">
                  <Link to="/parent/forgot" className="mobile-link small" onClick={() => setOpen(false)}><FaUnlockAlt /> Forgot Password</Link>
                  <Link to="/parent/change-school" className="mobile-link small" onClick={() => setOpen(false)}><FaSchool /> Change School</Link>
                  <button className="mobile-link text-danger bg-transparent border-0 text-start w-100" onClick={deleteAccount}><FaTrash /> Delete Account</button>
                </div>
                <button className="btn btn-light w-100 mt-4 rounded-pill fw-bold" onClick={logout}><FaSignOutAlt className="me-2" /> Logout</button>
              </>
            )}
          </div>
        </div>
      </div>

      <style>{`
        .settings-wrapper:hover .settings-dropdown { visibility: visible; opacity: 1; transform: translateY(0); }
        .settings-dropdown { position: absolute; right: 0; width: 200px; background: white; border-radius: 12px; margin-top: 5px; visibility: hidden; opacity: 0; transform: translateY(10px); transition: all 0.3s ease; z-index: 1000; border: 1px solid #eee; }
        .dropdown-item { color: #333; text-decoration: none; display: block; width: 100%; text-align: left; }
        .dropdown-item:hover { background-color: #f8f9fa; color: #097969; }
        .cog-icon { transition: transform 0.5s ease; color: white; }
        .settings-wrapper:hover .cog-icon { transform: rotate(90deg); }
        .mobile-menu-overlay { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: #097969; z-index: 1040; transform: translateX(100%); transition: transform 0.4s ease; padding-top: 80px; }
        .mobile-menu-overlay.active { transform: translateX(0); }
        .mobile-link { display: flex; align-items: center; gap: 15px; padding: 12px 20px; color: white; text-decoration: none; font-size: 16px; border-radius: 10px; }
      `}</style>
    </>
  );
}

export default Header;
